export const TaskDocumentStyles = () => {
  return {
    content: {
      fileName: {
        wordBreak: "break-all",
      },
    },
  };
};
